import React from 'react';
import { PhoneCall, MapPinned, Clock3, Wifi } from 'lucide-react';
import { PageHero } from '../components/shared';
import { LeadForm } from '../components/LeadForm';
export function Contact() {
  return <>
      <PageHero eyebrow="Get in touch" title="We answer the phone." subtitle="Call, email, or send a note through the form. A real Watchdog team member will reach out within one business day." data-id="element-234" />

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-id="element-235">
        <div className="grid gap-10 lg:grid-cols-[.95fr_1.05fr]" data-id="element-236">
          <div className="space-y-4" data-id="element-237">
            <a href="tel:+19168424729" className="block rounded-[2rem] border border-slate-200 bg-white p-6 transition hover:border-sky-300 hover:shadow-xl" data-id="element-238">
              <PhoneCall className="mb-4 h-7 w-7 text-sky-500" data-id="element-239" />
              <p className="text-sm font-black uppercase tracking-wider text-slate-500" data-id="element-240">
                Phone
              </p>
              <p className="mt-1 text-2xl font-black" data-id="element-241">(916) 842-4729</p>
            </a>

            <div className="rounded-[2rem] border border-slate-200 bg-white p-6" data-id="element-242">
              <MapPinned className="mb-4 h-7 w-7 text-sky-500" data-id="element-243" />
              <p className="text-sm font-black uppercase tracking-wider text-slate-500" data-id="element-244">
                Office
              </p>
              <p className="mt-1 text-lg font-bold text-slate-800" data-id="element-245">
                1021 Kirby Ct
                <br data-id="element-246" />
                Folsom, CA 95630
              </p>
              <a href="https://maps.google.com/?q=1021+Kirby+Ct+Folsom+CA+95630" target="_blank" rel="noreferrer" className="mt-4 inline-flex text-sm font-black text-sky-600 hover:text-sky-700" data-id="element-247">
                Get directions →
              </a>
            </div>

            <div className="rounded-[2rem] border border-slate-200 bg-white p-6" data-id="element-248">
              <Clock3 className="mb-4 h-7 w-7 text-sky-500" data-id="element-249" />
              <p className="text-sm font-black uppercase tracking-wider text-slate-500" data-id="element-250">
                Hours
              </p>
              <div className="mt-3 space-y-1 text-slate-700" data-id="element-251">
                <p data-id="element-252">
                  <span className="font-bold" data-id="element-253">Mon – Fri:</span> 7 AM – 9 PM
                </p>
                <p data-id="element-254">
                  <span className="font-bold" data-id="element-255">Sat – Sun:</span> 8 AM – 8 PM
                </p>
              </div>
            </div>

            <a href="https://www.alarm.com/US/watchdogsmarthome?home=1" target="_blank" rel="noreferrer" className="block rounded-[2rem] border border-slate-200 bg-slate-950 p-6 text-white transition hover:bg-slate-800" data-id="element-256">
              <Wifi className="mb-4 h-7 w-7 text-sky-300" data-id="element-257" />
              <p className="text-sm font-black uppercase tracking-wider text-sky-300" data-id="element-258">
                Existing customers
              </p>
              <p className="mt-1 text-lg font-bold" data-id="element-259">
                Sign in to your Alarm.com dashboard →
              </p>
            </a>
          </div>

          <LeadForm title="Send us a message" subtitle="Tell us about your property and what you are trying to solve." data-id="element-260" />
        </div>
      </section>
    </>;
}